<template src="./form.html"></template>

<script>
import { CreateDomain } from '@/api/domain'

export default {
  name: 'add-domain',
  data: function () {
    return {
      model: {
        studyid: this.$route.params.id,
        domain: '',
        label: null,
        instructions: '',
        note: null,
        repeated: null
      },
      ruleValidate: {
        domain: [{
          required: true,
          message: '表单名称不能为空',
          trigger: 'change'
        }],
        label: [{
          required: true,
          message: '表单标签不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateDomain(this.model).then(async res => {
        if (res.id) {
          this.$Message.success('已添加到成员列表！')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
